import { useQuery } from "@tanstack/react-query";
import type {
  SellarImportsPayoutListRequestType,
  SellarImportsPayoutListResponseType,
} from "@sellar-io/api-v2/types";
import { ServerStateKeys } from "../../../../../hooks/api/v2/ServerStateKeys";
import {
  ApiV2QueryOptions,
  apiV2Request,
  apiV2AssertResponse,
  getDefaultQueryOptionsV2,
} from "../../../../../hooks/api/v2/apiV2Request";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";

export const useSellarImportPayoutList = <
  TData = SellarImportsPayoutListResponseType,
>(
  params: SellarImportsPayoutListRequestType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.SellarImportsPayouts,
      params,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `sellar-imports/finance/payouts`,
        params,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: options,
    }),
  });
};
